import { config } from "@targeted-support/config";
import { useBranding } from "@targeted-support/ui/contexts";
import { ShieldCheck } from "lucide-react";
import { InitialMessage as InitialMessageType } from "./types";

/**
 * InitialMessage component displays a non-clickable initial assistant message.
 * Initial messages are compliant by design and always show a green shield icon.
 */
interface InitialMessageProps {
  message: InitialMessageType;
}

export const InitialMessage = ({ message }: InitialMessageProps) => {
  const { Logo, tenantId } = useBranding();

  return (
    <div className="flex w-full gap-2 text-left py-2 items-start">
      {/* Visual indicator for system/assistant message */}
      <div className="flex-shrink-0 mt-0.5">
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-primary/10 border border-brand-border">
          <Logo
            size={0.9}
            fill={
              tenantId === config.DEMO_ORGANISATION_ID ? "#B11082" : undefined
            }
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm leading-relaxed text-brand-foreground">
          {message.content}
        </p>
        {/* Shield icon - initial messages are compliant by design */}
        <div className="mt-2">
          <div className="flex h-6 items-center gap-1 rounded-full border border-brand-border bg-brand-card px-3 text-xs font-medium text-brand-foreground shadow-sm w-fit">
            <ShieldCheck
              className="h-4 w-4 text-green-600"
              fill="currentColor"
              stroke="white"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
